import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const ProjectPurchaseorderSupplieritemListComponent = (props) => {

  const {t} = props;
  const [purchaseOrderSupplierItems, setPurchaseOrderSupplierItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/purchase-order-supplier-item?search[project][operator]==&search[project][value]=' + props.projectId + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setPurchaseOrderSupplierItems(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const formatUnitPrice = (rowData) => {
    const currency = rowData.purchase_order_supplier?.currency || process.env.REACT_APP_CURRENCY_DEFAULT || 'HUF';

    return window.App?.currencyFormatter
      ? window.App.currencyFormatter(currency, rowData.unit_price)
      : <>{Number(rowData.unit_price || 0)}&nbsp;{currency}</>;
  }

  const hasActiveFilters = (filters) => {
    return Object.values(filters || {}).some(filter => {
      return filter?.value !== null && filter?.value !== undefined && filter?.value !== '';
    });
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderProjectPurchaseorderSupplieritemList])

  return (
  <>
    {!loading && purchaseOrderSupplierItems.length === 0 && !hasActiveFilters(lazyParams.filters) ? (
      <p className="p-m-3">{t('noPurchasedMaterialsForProject')}</p>
    ) : (
      <DataTable
        size={localStorage.getItem('scale')}
        emptyMessage={t('noResults')}
        value={purchaseOrderSupplierItems}
        paginator
        first={lazyParams.first}
        totalRecords={totalRecords}
        onPage={onPage}
        onSort={onSort}
        sortField={lazyParams.sortField}
        sortOrder={lazyParams.sortOrder}
        onFilter={onFilter}
        filters={lazyParams.filters}
        loading={loading}
        lazy
        paginatorTemplate={pager}
        rows={rows}
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
        ref={dt}
        dataKey="id"
      >
        <Column field="material.name" header={t('columnProduct')} sortable filter filterField='material_name'></Column>
        <Column field="material.sku" header={t('sku')} sortable></Column>
        <Column field="unit_price" header={t('columnUnitPrice')} sortable body={formatUnitPrice}></Column>
        <Column field="vat_rate.label" header={t('columnVat')} sortable></Column>
        <Column header={t('columnQuantity')} sortable body={(rowData) => {
          return <>{rowData.quantity} {rowData.unit?.name}</>;
        }}></Column>
        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return <>{window.App.formatDateValue(rowData.created_at)}</>;
        }}></Column>
      </DataTable>
    )}
  </>
)
}
export default withTranslation('common')(ProjectPurchaseorderSupplieritemListComponent);
